import { FC, useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header/Header";
import Sidebar from "../base-components/Sidebar";
import { useRecoilState } from "recoil";
import { isLoggedInSelector } from "../actions/Authentication.actions";
import { getItem } from "../hooks/useCookie";
import { layoutTheme } from "../theme/theme-constants";
import { layoutThemeSelector } from "../actions/LayoutMode.actions";
import useOutsideClick from "../hooks/useOutsideClick";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import paths from "../route/paths";

type Props = {
  children: React.ReactNode;
};

const changeBodyAttribute = (attribute: any, value: any) => {
  if (document.body) document.body.setAttribute(attribute, value);
  return true;
};

const Layout: FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const ref: any = useRef();

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const darkMode = getItem("darkMode");

  const [isLoggedIn, setLoggedIn] = useRecoilState(isLoggedInSelector);

  const [sidebarIsOpen, setSidebarIsOpen] = useState(isMobile ? false : true);
  const [, setLayoutMode] = useRecoilState(layoutThemeSelector);

  useOutsideClick(ref, setSidebarIsOpen);

  useEffect(() => {
    if (darkMode === "darkMode") {
      setLayoutMode({ layoutMode: "dark" });

      changeBodyAttribute("data-bs-theme", layoutTheme["DARKMODE"]);
      changeBodyAttribute("data-topbar", layoutTheme["DARKMODE"]);
      changeBodyAttribute("data-sidebar", layoutTheme["DARKMODE"]);
    }

    if (darkMode === "lightMode") {
      setLayoutMode({ layoutMode: "light" });

      changeBodyAttribute("data-bs-theme", layoutTheme["LIGHTMODE"]);
      changeBodyAttribute("data-topbar", layoutTheme["LIGHTMODE"]);
      changeBodyAttribute("data-sidebar", layoutTheme["LIGHTMODE"]);
    }
  }, []);

  useEffect(() => {
    isLoggedIn.isLoggedIn === false && navigate(paths.AUTHENTICATION.LOGIN);
  }, [isLoggedIn]);

  return (
    <div id="layout-wrapper">
      {isLoggedIn.isLoggedIn && (
        <Header
          isMobile={isMobile}
          sidebarIsOpen={sidebarIsOpen}
          setSidebarIsOpen={setSidebarIsOpen}
        />
      )}

      {isLoggedIn.isLoggedIn && (
        <Sidebar setSidebarIsOpen={setSidebarIsOpen} ref={ref} />
      )}

      <div
        style={{
          marginLeft: isLoggedIn.isLoggedIn
            ? `${sidebarIsOpen ? "250px" : "70px"}`
            : "0px",
        }}
        className="main-content"
      >
        {children}
      </div>

      {isLoggedIn.isLoggedIn && <Footer />}

      <ToastContainer />
    </div>
  );
};

export default Layout;
